// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w5MW","fullView":"styles_fullView__2P9vR"};